import React, { CSSProperties } from 'react';
import { Button as AntdButton, ButtonProps } from 'antd';

const actionButton: CSSProperties = {
  width: '100%',
  height: '60px',
  border: '1px solid #ee8865',
  padding: '2px',
  fontWeight: 300,
  fontSize: '16px',
  lineHeight: '22px',
  fontFamily: 'Open Sans, sans-serif',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  letterSpacing: '0.03em',
  margin: '5px 0',
  cursor: 'pointer',
  transition: 'opacity 0.3s',
  borderRadius: '8px',
  color: '#000000',
};

export const Button: React.FC<ButtonProps> = ({ children, style, ...props }) => {
  return (
    <AntdButton {...props} style={{ ...actionButton, ...style }}>
      {children}
    </AntdButton>
  );
};
